module.exports = __webpack_public_path__ + "static/media/link_02.d9515c1d.jpg";